"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTheme = exports.ThemeProvider = void 0;
const react_1 = __importStar(require("react"));
const ctx = react_1.default.createContext('greenish');
const ThemeProvider = ({ theme, children }) => {
    react_1.useEffect(() => {
        const { document } = globalThis;
        if (document) {
            const { body } = document;
            body.classList.forEach(klass => {
                if (klass.startsWith('theme-')) {
                    body.classList.remove(klass);
                }
            });
            body.classList.add(`theme-${theme}`);
        }
    }, [theme]);
    if (process.env.REACT_APP_THEME) {
        require(`./${process.env.REACT_APP_THEME}.theme.css`);
    }
    else {
        require(`./${theme}.theme.css`);
    }
    return react_1.default.createElement(ctx.Provider, { value: theme }, children);
};
exports.ThemeProvider = ThemeProvider;
const useTheme = () => {
    return react_1.useContext(ctx);
};
exports.useTheme = useTheme;
//# sourceMappingURL=ThemeProvider.js.map